import { renderObjectIcon } from '../utils/icons';
import BusinessProcessBase, { TextLabelBehaviors } from './BusinessProcessBase';
import ShapeCircle from './ShapeCircle';

@TextLabelBehaviors
class ShapeBusinessProcessEvent extends BusinessProcessBase {
  static defaultWidth() {
    return 55;
  }

  static defaultHeight() {
    return 55;
  }

  static pathString() {
    return ShapeCircle.pathString();
  }

  render(ctx: CanvasRenderingContext2D) {
    super.render(ctx);

    // Render the icon centred within the shape
    if (this.icon) {
      renderObjectIcon(
        ctx,
        this.icon,
        42 * this.fabricObject.scaleX,
        'center',
        this.fabricObject
      );
    }
  }
}

export default ShapeBusinessProcessEvent;
